import { SERVICE_TYPES, SELECT_SERVICES_LIST, SCROLL_TO_TYPE } from './constants';

class Helper {
  isIndoor(menu) {
    return menu.takeaway || menu.shortDelivery || menu.inStore || menu.voucher || menu.dineIn;
  }

  countIndoor(menu) {
    const Indoor = {
      shortDelivery: menu.shortDelivery,
      takeaway: menu.takeaway,
      voucher: menu.voucher,
      inStore: menu.inStore,
      dineIn: menu.dineIn,
    };
    const contador = Object.keys(Indoor).filter(item => Indoor[item] === true).length;

    return contador;
  }

  moveItem(fromParam, toParam, array) {
    const list = array.slice();
    const from = array.findIndex(e => e.sortOrder === fromParam);
    const to = array.findIndex(e => e.sortOrder === toParam);

    const element = list[from];
    list.splice(from, 1);
    list.splice(to, 0, element);
    return list.map((item, i) => {
      return {
        ...item,
        sortOrder: i + 1,
      };
    });
  }

  filterPossibleMarketplaces({ marketplaces, menus, serviceTypes = [], editMenu }) {
    return marketplaces.map(mktpc => {
      const isDelivery = this.hasServiceType(mktpc, menus, 'delivery');
      const isIndoor = this.hasServiceType(mktpc, menus, 'indoor');
      const hasEditMenu = !!Object.keys(editMenu).length;
      const serviceTypesCheck = serviceTypes.length
        ? (isDelivery && isIndoor) ||
          serviceTypes.some(type => this.hasServiceType(mktpc, menus, type))
        : isDelivery && isIndoor;
      const blockDisableEditMenuMtkpc = hasEditMenu
        ? this.verifyEditMenuDisabled(serviceTypesCheck, editMenu, mktpc)
        : serviceTypesCheck;
      return {
        ...mktpc,
        disabled: hasEditMenu ? blockDisableEditMenuMtkpc : serviceTypesCheck,
      };
    });
  }

  verifyEditMenuDisabled(serviceTypesCheck, editMenu, mktpc) {
    return editMenu.marketplaces.some(menuMtkpc => menuMtkpc === mktpc.id)
      ? false
      : serviceTypesCheck;
  }

  hasServiceType(mktpc, menus, serviceType = 'delivery') {
    return menus.some(menu => {
      if (menu.marketplaces.some(menuMktpc => menuMktpc === mktpc.id)) {
        return serviceType === 'delivery' ? menu.delivery : this.isIndoor(menu);
      }
      return false;
    });
  }

  serializeMarketplaces(marketplaces) {
    return marketplaces.map(mktpc => ({
      id: mktpc.id,
      label: mktpc.name,
      disabled: mktpc.disabled,
      active: !!mktpc.active,
    }));
  }

  formatServiceTypeNames(menu) {
    const qtdIndoor = this.countIndoor(menu);
    let serviceTypeNames = menu.delivery ? 'Delivery' : '';
    if (qtdIndoor) {
      serviceTypeNames += `${menu.delivery ? ' / ' : ''}No local (`;
      serviceTypeNames += SERVICE_TYPES.filter(service => {
        return !(service.value === 'delivery') && menu[service.value] ? service.label : false;
      })
        .map(item => item.label)
        .join(', ');
      serviceTypeNames += ')';
    }
    return serviceTypeNames;
  }

  formatProducts(categories) {
    return categories.map(category => {
      const products = category.products.length
        ? category.products.map(product => {
            return {
              ...product,
              categoryId: category.id,
              checked: false,
            };
          })
        : [];

      return {
        ...category,
        checked: false,
        isOpen: products.length > 0,
        products,
      };
    });
  }

  formatDate(date = new Date()) {
    const day = date
      .getDate()
      .toString()
      .padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const hours = date
      .getHours()
      .toString()
      .padStart(2, '0');
    const minutes = date
      .getMinutes()
      .toString()
      .padStart(2, '0');
    return `${day}/${month} - ${hours}:${minutes}`;
  }

  formatStringDate = (str = '') => str.replace(/\s/, 'T');

  serializeServiceTypes(serviceTypesList = SELECT_SERVICES_LIST, merchant) {
    return merchant
      ? serviceTypesList.map(type => ({
          ...type,
          options: type.options.map(opt => {
            return {
              ...opt,
              disabled: !merchant[opt.enableName],
            };
          }),
        }))
      : serviceTypesList;
  }

  formatFileSize = size => size / 1000000;

  formatBase64ToSend = (base64Value = '') => {
    return base64Value.split(',')[1];
  };

  removeTextFromString = str => parseInt(str.toString().replace(/\D/g, ''), 10);

  getHigherValueInArray = arr => Math.max.apply(Math, arr);

  getCurrentMerchantId = () => {
    const { pathname } = window.location;
    return pathname.replace('/merchant/', '').split('/')[0];
  };

  formatItemToScrollInto = (data, type) => {
    return {
      id: data.id,
      categoryId: type === SCROLL_TO_TYPE.product ? data.categories[0].id : null,
      type,
    };
  };

  scrollToElement = element => {
    const absoluteElementTop = element.getBoundingClientRect().top + window.pageYOffset;
    const middle = absoluteElementTop - window.innerHeight / 2;
    window.scrollTo(0, middle);
  };

  formatApiErrorResponse = ({ response, message }) => {
    if (response) {
      return {
        ...response,
        message,
      };
    }
    return {
      status: 0,
      message,
    };
  };
}

export default new Helper();



// WEBPACK FOOTER //
// ./src/helpers/Helper.js